import useDocumentTitle from 'src/hooks/useDocumentTitle'

function usePipelineDocumentTitle(title?: string) {
  const baseTitle = 'Pipeline'
  const subTitle = title ? `${title} -` : ''

  useDocumentTitle(`${subTitle} ${baseTitle}`)
}

export default usePipelineDocumentTitle
